import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  CheckboxToggleDef,
  ControlType,
} from '@domgen/dgx-fe-dynamic-form-builder';

@Component({
  selector: 'sky-read-and-accept-policy',
  templateUrl: './read-and-accept-policy.component.html',
  styleUrls: ['./read-and-accept-policy.component.scss'],
})
export class ReadAndAcceptPolicyComponent implements AfterViewInit {
  @Output() form: EventEmitter<UntypedFormGroup> = new EventEmitter();
  public formGroup = new UntypedFormGroup({
    acceptPolicy: new UntypedFormControl('', Validators.requiredTrue),
  });
  field: CheckboxToggleDef = {
    controlType: ControlType.CHECKBOX,
    controlName: 'acceptPolicy',
    initialValue: false,
    validators: [Validators.required],
    validationMessages: [
      {
        type: 'required',
        message:
          'Please confirm that you have read and accept the documents provided.',
      },
    ],
    label: {
      text: 'I’ve read the document and confirm my devices and Sky equipment are in good working order',
    },
  };

  ngAfterViewInit() {
    this.form.emit(this.formGroup);
  }
}
